import { websiteBuilderGenerateDefaultButton } from "../../element/websiteBuilderButton";
import { WebsiteBuilderDividerWeight, websiteBuilderGenerateDefaultDivider } from "../../element/websiteBuilderDivider";
import { websiteBuilderGenerateDefaultHeading } from "../../element/websiteBuilderHeading";
import { websiteBuilderGenerateDefaultParagraph } from "../../element/websiteBuilderParagraph";
import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderContent, websiteBuilderGenerateDefaultContent } from "../websiteBuilderContent";
import { websiteBuilderGenerateTemplateImage } from "./websiteBuilderResolveTemplateMedia";

export function websiteBuilderEventsTemplate(media: IWebsiteBuilderMediaItem[]): IWebsiteBuilderContent {
  const section = websiteBuilderGenerateDefaultContent();
  const subHeading = websiteBuilderGenerateDefaultParagraph();
  const subHeadingDivider = websiteBuilderGenerateDefaultDivider();
  const firstImage = websiteBuilderGenerateTemplateImage(media, "gold-wedding-band");
  const firstHeading = websiteBuilderGenerateDefaultHeading();
  const firstDescription = websiteBuilderGenerateDefaultParagraph();
  const firstDetails = websiteBuilderGenerateDefaultParagraph();
  const firstButton = websiteBuilderGenerateDefaultButton();
  const secondImage = websiteBuilderGenerateTemplateImage(media, "room-with-tables-and-chairs");
  const secondHeading = websiteBuilderGenerateDefaultHeading();
  const secondDescription = websiteBuilderGenerateDefaultParagraph();
  const secondDetails = websiteBuilderGenerateDefaultParagraph();
  const secondButton = websiteBuilderGenerateDefaultButton();

  section.section.layout.desktop.height = 745;
  section.section.layout.tablet.height = 530;
  section.section.layout.mobile.height = 960;

  subHeading.element.layout.desktop.position = { x: 80, y: 80 };
  subHeading.element.layout.tablet.position = { x: 32, y: 40 };
  subHeading.element.layout.mobile.position = { x: 25, y: 40 };
  subHeading.element.layout.desktop.dimensions = { width: 125, height: 25 };
  subHeading.element.layout.tablet.dimensions = { width: 125, height: 25 };
  subHeading.element.layout.mobile.dimensions = { width: 125, height: 25 };
  subHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "12px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "UPCOMING EVENTS", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  subHeadingDivider.element.layout.desktop.position = { x: 210, y: 89 };
  subHeadingDivider.element.layout.tablet.position = { x: 162, y: 49 };
  subHeadingDivider.element.layout.mobile.position = { x: 155, y: 49 };
  subHeadingDivider.element.layout.desktop.dimensions = { width: 125, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.tablet.dimensions = { width: 100, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.mobile.dimensions = { width: 90, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.settings.weight = WebsiteBuilderDividerWeight.THIN;
  subHeadingDivider.element.settings.color = "#285E1A";

  firstImage.element.layout.desktop.position = { x: 80, y: 115 };
  firstImage.element.layout.tablet.position = { x: 32, y: 75 };
  firstImage.element.layout.mobile.position = { x: 25, y: 75 };
  firstImage.element.layout.desktop.dimensions = { width: 405, height: 365 };
  firstImage.element.layout.tablet.dimensions = { width: 340, height: 245 };
  firstImage.element.layout.mobile.dimensions = { width: 270, height: 230 };
  firstImage.element.settings.alt = "Wedding rings"; // TODO: Translation
  firstImage.element.settings.borderRadius = 10;

  firstHeading.element.layout.desktop.position = { x: 80, y: 500 };
  firstHeading.element.layout.tablet.position = { x: 32, y: 335 };
  firstHeading.element.layout.mobile.position = { x: 25, y: 320 };
  firstHeading.element.layout.desktop.dimensions = { width: 405, height: 40 };
  firstHeading.element.layout.tablet.dimensions = { width: 340, height: 35 };
  firstHeading.element.layout.mobile.dimensions = { width: 270, height: 35 };
  firstHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "28px",
        tablet: "24px",
        mobile: "18px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.15" },
      content: [{
        type: "text",
        text: "Wedding open house", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  firstDescription.element.layout.desktop.position = { x: 80, y: 540 };
  firstDescription.element.layout.tablet.position = { x: 32, y: 372 };
  firstDescription.element.layout.mobile.position = { x: 25, y: 360 };
  firstDescription.element.layout.desktop.dimensions = { width: 405, height: 25 };
  firstDescription.element.layout.tablet.dimensions = { width: 340, height: 25 };
  firstDescription.element.layout.mobile.dimensions = { width: 270, height: 25 };
  firstDescription.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.3" },
      content: [{
        type: "text",
        text: "Step inside our venue!", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  firstDetails.element.layout.desktop.position = { x: 80, y: 585 };
  firstDetails.element.layout.tablet.position = { x: 32, y: 414 };
  firstDetails.element.layout.mobile.position = { x: 25, y: 390 };
  firstDetails.element.layout.desktop.dimensions = { width: 405, height: 25 };
  firstDetails.element.layout.tablet.dimensions = { width: 340, height: 25 };
  firstDetails.element.layout.mobile.dimensions = { width: 270, height: 25 };
  firstDetails.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "13px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "Saturday, July 18th | 12-3pm | Free entry", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  firstButton.element.layout.desktop.position = { x: 80, y: 621 };
  firstButton.element.layout.tablet.position = { x: 32, y: 446 };
  firstButton.element.layout.mobile.position = { x: 25, y: 425 };
  firstButton.element.layout.desktop.dimensions = { width: 95, height: 44 };
  firstButton.element.layout.tablet.dimensions = { width: 95, height: 44 };
  firstButton.element.layout.mobile.dimensions = { width: 110, height: 44 };
  firstButton.element.settings.label = "Book now"; // TODO: Translation
  firstButton.element.settings.backgroundColor = "#285E1A";
  firstButton.element.settings.borderColor = "#285E1A";
  firstButton.element.settings.color = "#FFFFFF";
  firstButton.element.settings.borderRadius = 10;

  secondImage.element.layout.desktop.position = { x: 515, y: 115 };
  secondImage.element.layout.tablet.position = { x: 396, y: 75 };
  secondImage.element.layout.mobile.position = { x: 25, y: 510 };
  secondImage.element.layout.desktop.dimensions = { width: 405, height: 365 };
  secondImage.element.layout.tablet.dimensions = { width: 340, height: 245 };
  secondImage.element.layout.mobile.dimensions = { width: 270, height: 230 };
  secondImage.element.settings.alt = "Bistro dining room"; // TODO: Translation
  secondImage.element.settings.borderRadius = 10;

  secondHeading.element.layout.desktop.position = { x: 515, y: 500 };
  secondHeading.element.layout.tablet.position = { x: 396, y: 335 };
  secondHeading.element.layout.mobile.position = { x: 25, y: 755 };
  secondHeading.element.layout.desktop.dimensions = { width: 405, height: 40 };
  secondHeading.element.layout.tablet.dimensions = { width: 340, height: 35 };
  secondHeading.element.layout.mobile.dimensions = { width: 270, height: 35 };
  secondHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "28px",
        tablet: "24px",
        mobile: "18px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.15" },
      content: [{
        type: "text",
        text: "The Bistro", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  secondDescription.element.layout.desktop.position = { x: 515, y: 540 };
  secondDescription.element.layout.tablet.position = { x: 396, y: 372 };
  secondDescription.element.layout.mobile.position = { x: 25, y: 795 };
  secondDescription.element.layout.desktop.dimensions = { width: 405, height: 40 };
  secondDescription.element.layout.tablet.dimensions = { width: 340, height: 40 };
  secondDescription.element.layout.mobile.dimensions = { width: 270, height: 35 };
  secondDescription.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.3" },
      content: [{
        type: "text",
        text: "Experience dining that will delight both your eyes and your palate.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  secondDetails.element.layout.desktop.position = { x: 515, y: 585 };
  secondDetails.element.layout.tablet.position = { x: 396, y: 414 };
  secondDetails.element.layout.mobile.position = { x: 25, y: 840 };
  secondDetails.element.layout.desktop.dimensions = { width: 405, height: 25 };
  secondDetails.element.layout.tablet.dimensions = { width: 340, height: 25 };
  secondDetails.element.layout.mobile.dimensions = { width: 270, height: 25 };
  secondDetails.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "13px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "Sunday, July 19th | 8-10pm | 200 capacity", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  secondButton.element.layout.desktop.position = { x: 515, y: 621 };
  secondButton.element.layout.tablet.position = { x: 396, y: 446 };
  secondButton.element.layout.mobile.position = { x: 25, y: 875 };
  secondButton.element.layout.desktop.dimensions = { width: 105, height: 44 };
  secondButton.element.layout.tablet.dimensions = { width: 105, height: 44 };
  secondButton.element.layout.mobile.dimensions = { width: 110, height: 44 };
  secondButton.element.settings.label = "Learn more"; // TODO: Translation
  secondButton.element.settings.backgroundColor = "#285E1A";
  secondButton.element.settings.borderColor = "#285E1A";
  secondButton.element.settings.color = "#FFFFFF";
  secondButton.element.settings.borderRadius = 10;

  section.children = [
    subHeading,
    subHeadingDivider,
    firstImage,
    firstHeading,
    firstDescription,
    firstDetails,
    firstButton,
    secondImage,
    secondHeading,
    secondDescription,
    secondDetails,
    secondButton,
  ];

  return section;
}
